import WelcomeBonus from './WelcomeBonus';
export default WelcomeBonus;
